<div class="acc-tap" *ngIf="step === 'form'">
  <h3 class="acc-tap-title">{{ "changePhone" | translate }}</h3>
  <hr class="m-0" />
  <form
    [formGroup]="phoneForm"
    (ngSubmit)="onSubmit()"
    class="space-y-4"
  >
    <div class="acc-tap-content">
      <!-- Current Phone -->
      <div class="form-group">
        <label
          for="currentPhone"
          [class]="
            phoneForm.controls['currentPhone'].touched
              ? phoneForm.controls['currentPhone'].valid
                ? 'label-base text-green-500'
                : 'label-base text-red-500'
              : 'label-base'
          "
        >
          {{ "currentPhoneLabel" | translate }}
          <span>*</span>
        </label>

        <input
          type="text"
          id="currentPhone"
          formControlName="currentPhone"
          class="form-control border rounded w-full p-2"
          maxlength="15"
          autocomplete="tel"
          [ngClass]="{
            'border-red-500':
              phoneForm.controls['currentPhone'].touched &&
              phoneForm.controls['currentPhone'].invalid,
            'border-green-500':
              phoneForm.controls['currentPhone'].touched &&
              phoneForm.controls['currentPhone'].valid
          }"
        />

        <span
          *ngIf="phoneForm.controls['currentPhone'].touched"
          [ngClass]="{
            'text-red-500': phoneForm.controls['currentPhone'].invalid || phoneForm.errors?.['currentPhoneMismatch'],
            'text-green-500': phoneForm.controls['currentPhone'].valid && !phoneForm.errors?.['currentPhoneMismatch']
          }"
          class="text-sm"
        >
          <ng-container *ngIf="phoneForm.controls['currentPhone'].errors?.['required']">
            {{ "currentPhoneRequired" | translate }}
          </ng-container>
          <ng-container *ngIf="phoneForm.errors?.['currentPhoneMismatch']">
            {{ "phoneMismatch" | translate }}
          </ng-container>
          <ng-container *ngIf="phoneForm.controls['currentPhone'].errors?.['pattern']">
            {{ "phoneInvalidError" | translate }}
          </ng-container>
        </span>
      </div>

      <!-- New Phone -->
      <div class="form-group">
        <label
          for="newPhone"
          [class]="
            phoneForm.controls['newPhone'].touched
              ? phoneForm.controls['newPhone'].valid
                ? 'label-base text-green-500'
                : 'label-base text-red-500'
              : 'label-base'
          "
        >
          {{ "newPhoneLabel" | translate }}
          <span>*</span>
        </label>

        <input
          type="text"
          id="newPhone"
          formControlName="newPhone"
          class="form-control border rounded w-full p-2"
          maxlength="15"
          autocomplete="off"
          [ngClass]="{
            'border-red-500':
              phoneForm.controls['newPhone'].touched &&
              phoneForm.controls['newPhone'].invalid,
            'border-green-500':
              phoneForm.controls['newPhone'].touched &&
              phoneForm.controls['newPhone'].valid
          }"
        />

        <span
          *ngIf="
            phoneForm.controls['newPhone'].touched &&
            phoneForm.controls['newPhone'].errors
          "
          [ngClass]="{
            'text-red-500': phoneForm.controls['newPhone'].invalid,
            'text-green-500': phoneForm.controls['newPhone'].valid
          }"
          class="text-sm"
        >
          <ng-container *ngIf="phoneForm.controls['newPhone']?.errors?.['required']">
            {{ "newPhoneRequired" | translate }}
          </ng-container>
          <ng-container *ngIf="phoneForm.controls['newPhone']?.errors?.['pattern']">
            {{ "phoneInvalidError" | translate }}
          </ng-container>
        </span>
      </div>

      <!-- Confirm New Phone -->
      <div class="form-group">
        <label
          for="confirmNewPhone"
          [class]="
            phoneForm.controls['confirmNewPhone'].touched
              ? phoneForm.controls['confirmNewPhone'].valid && !phoneForm.errors?.['newPhoneMismatch']
                ? 'label-base text-green-500'
                : 'label-base text-red-500'
              : 'label-base'
          "
        >
          {{ "confirmNewPhoneLabel" | translate }}
          <span>*</span>
        </label>

        <input
          type="text"
          id="confirmNewPhone"
          formControlName="confirmNewPhone"
          class="form-control border rounded w-full p-2"
          maxlength="15"
          autocomplete="off"
          [ngClass]="{
            'border-red-500':
              phoneForm.controls['confirmNewPhone'].touched &&
              (phoneForm.controls['confirmNewPhone'].invalid || phoneForm.errors?.['newPhoneMismatch']),
            'border-green-500':
              phoneForm.controls['confirmNewPhone'].touched &&
              phoneForm.controls['confirmNewPhone'].valid &&
              !phoneForm.errors?.['newPhoneMismatch']
          }"
        />

        <span
          *ngIf="phoneForm.controls['confirmNewPhone'].touched &&
                  (phoneForm.controls['confirmNewPhone'].errors || phoneForm.errors?.['newPhoneMismatch'])"
          [ngClass]="{
            'text-red-500': phoneForm.controls['confirmNewPhone'].invalid || phoneForm.errors?.['newPhoneMismatch'],
            'text-green-500': phoneForm.controls['confirmNewPhone'].valid && !phoneForm.errors?.['newPhoneMismatch']
          }"
          class="text-sm"
        >
          <ng-container *ngIf="phoneForm.controls['confirmNewPhone'].errors?.['required']">
            {{ "confirmNewPhoneRequired" | translate }}
          </ng-container>
          <ng-container *ngIf="phoneForm.errors?.['newPhoneMismatch']">
            {{ "phoneMismatchError" | translate }}
          </ng-container>
        </span>
      </div>
    </div>

    <div *ngIf="apiError" class="text-red-500 text-sm mb-2 d-flex justify-content-center">
      {{ apiError }}
    </div>

    <hr class="m-0" />
    <div class="acc-tap-footer">
      <button type="submit" class="main-btn">
        <i class="fa-regular fa-pen-to-square"></i>
        {{ "save" | translate }}
      </button>
    </div>
  </form>
</div>

<div class="acc-tap" *ngIf="step === 'otp'">
  <h3 class="acc-tap-title">{{ "verifyOTP" | translate }}</h3>
  <hr class="m-0" />
  <div class="acc-tap-content">
    <div class="otp-container">
      <p class="otp-description">
        {{ "otpSentToPhone" | translate }}:
        <strong dir="ltr" class="phone-display">{{ phoneForm.value.newPhone }}</strong>
      </p>
      <app-otp-input
        [phoneNumber]="phoneForm.value.newPhone"
        [generateNewOtp]="false"
        [externalResend]="true"
        [operationType]="3"
        (resendRequested)="resendPhoneOtp()"
        (onValidationSuccess)="handleOtpSuccess($event)"
        (onValidationFailed)="handleOtpFailed($event)"
      ></app-otp-input>
    </div>
  </div>
  <div *ngIf="apiError" class="text-red-500 text-sm mb-2 d-flex justify-content-center mt-3">
    {{ apiError }}
  </div>
</div>
